import { Box, Typography } from '@material-ui/core';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import { OLB_CARD_ON_FILE_ENABLED_KEY, saveCardOnFileThunk } from '@spike/marketplace-action';
import { SETTINGS_TRUE_VALUE } from '@spike/marketplace-model';
import { reduceResolution, wbp } from 'Theme';
import clsx from 'clsx';
import { Switch } from 'components/UI';
import { useSettingsApiClientWrapper } from 'hooks';
import { FunctionComponent, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';

export interface Props {
    disabled?: boolean;
    className?: string;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            borderTop: '1px solid #E5E5E5',
            [theme.breakpoints.down(wbp)]: {
                marginTop: `${reduceResolution(47)}px`,
                paddingTop: `${reduceResolution(47)}px`
            },
            [theme.breakpoints.up(wbp)]: {
                marginTop: '47px',
                paddingTop: '47px'
            }
        },
        header: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        },
        title: {
            color: '#222222',
            fontWeight: 600,
            fontSize: '16px',
            [theme.breakpoints.down('sm')]: {
                fontSize: '16px'
            }
        },
        description: {
            color: '#222222',
            marginTop: '8px',
            fontSize: '16px',
            lineHeight: '25px',
            [theme.breakpoints.down('sm')]: {
                marginTop: `${reduceResolution(20)}px`,
                fontSize: '14px',
                lineHeight: '140%'
            }
        }
    })
);

export const CardOnFile: FunctionComponent<Props> = props => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const apiClientWrapper = useSettingsApiClientWrapper();

    const settings = useSelector((state: RootState) => state.marketplace.settingsMarketplace.settings);
    const savedEnabled =
        settings.find(setting => setting.key === OLB_CARD_ON_FILE_ENABLED_KEY)?.value === SETTINGS_TRUE_VALUE;

    const [enabled, setEnabled] = useState(savedEnabled);

    const toggleHandler = (checked: boolean) => {
        setEnabled(checked);
        dispatch(saveCardOnFileThunk(apiClientWrapper, checked));
    };

    return (
        <Box className={clsx(classes.container, props.className)}>
            <Box className={classes.header}>
                <Typography className={classes.title}>Card On File</Typography>
                <Switch
                    id="olb_settings_card_on_file"
                    checked={enabled}
                    disabled={props.disabled}
                    onChange={toggleHandler}
                />
            </Box>
            <Typography className={classes.description}>
                Require clients to securely add a credit or debit card when completing their online booking.
            </Typography>
        </Box>
    );
};

export default CardOnFile;
